import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurycabrentalswithdriverinpune() {



  const cardData =
  {
    keyword: 'Luxury Cab Rentals with Drivers in Pune',
    heading: 'Aaryan Travels: Luxury Cab Rentals with Drivers in Pune',
    headingDescription: 'Aaryan Travels offers premium Luxury Cab Rentals with Drivers in Pune for corporate executives, VIP guests, weddings, and leisure travelers who prefer comfort and class on the move. Whether it’s an airport pickup from Pune International Airport, a high-level business meeting in Kalyani Nagar, or a luxury ride to Mahabaleshwar or Lonavala, our fleet of high-end sedans and SUVs—including Mercedes, BMW, and Innova Crysta—ensures a refined travel experience. With uniformed chauffeurs, spotless interiors, and on-request amenities like bottled water and Wi-Fi, we deliver first-class travel with punctuality and professionalism. From Koregaon Park to Hinjewadi, Baner to Magarpatta, Aaryan Travels is your trusted partner for chauffeur-driven luxury cab rentals in Pune.',

    top: 'Top Places to Visit in Pune with Aaryan Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace. Once the seat of Maratha power, it still carries tales of bravery and the legendary romance of Bajirao and Mastani. Visitors explore its grand gateways, fountains, and sprawling lawns. The evening light-and-sound show brings history to life. Shaniwar Wada is Pune’s proud emblem of heritage and valor."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, built in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum housing Gandhi’s personal belongings. The palace’s Italian arches and lush gardens add grace. Aga Khan Palace is Pune’s symbol of sacrifice and peace."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located atop a hill 25 km from Pune, is known for the 1670 battle where Tanaji Malusare fought valiantly for Shivaji Maharaj. Trekkers enjoy climbing the scenic trail, especially in monsoon. The fort offers panoramic views of the Sahyadris and local delicacies like pithla-bhakri served at the top. Sinhagad is Pune’s perfect mix of adventure and history."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, draws thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the center of grand festivities. The divine aura fills every visitor with peace. Dagdusheth is Pune’s spiritual heartbeat."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Featuring monolithic pillars and a sacred sanctum, it reflects ancient Indian craftsmanship. Despite being in the city center, the temple offers a serene escape. Evening chants enhance its mystical ambiance. Pataleshwar is Pune’s hidden gem of tranquility."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. The exhibits include musical instruments, sculptures, ornaments, and everyday antiques from across India. The recreated Mastani Mahal is a major attraction. It is a paradise for history lovers. The museum is Pune’s treasure chest of art and culture."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill offers breathtaking views of Pune city from its summit. Visitors climb 103 steps to reach the temple dedicated to Lord Shiva and Goddess Parvati. Built during the Peshwa era, the temple showcases traditional architecture. Sunrises and sunsets from the hill are mesmerizing. Parvati Hill is Pune’s peaceful spiritual escape."
  },
  {
    "title": "Osho Ashram",
    "description": "Osho Ashram in Koregaon Park is an international meditation resort offering healing therapies, spiritual workshops, and wellness programs. Surrounded by lush greenery and modern architecture, it attracts visitors from around the world. The serene ambiance promotes deep relaxation. Osho Ashram is Pune’s global hub of mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Inspired by Japan’s Korakuen Garden, Pu La Deshpande Garden is Pune’s largest landscaped park. It features flowing streams, stone bridges, and blossoming trees. Families enjoy picnics, evening walks, and photography sessions. Seasonal flowers add vibrant charm throughout the year. The garden is Pune’s refreshing green retreat."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular picnic spot near Pune. The scenic water body and surrounding hills offer a picturesque setting, especially during monsoon. Vendors selling roasted corn and tea enhance the experience. It also serves as the base for trips to Sinhagad Fort. Khadakwasla is Pune’s breezy nature getaway."
  }
],


"services": [
  {
    "name": "Luxury Cab Rentals with Drivers in Pune",
    "description": "Luxury Cab Rentals with Drivers in Pune provide an elite transportation experience for discerning travelers seeking comfort, style, and convenience. Our fleet consists of high-end vehicles driven by professional chauffeurs trained to offer courteous, safe, and punctual service. Whether it’s for corporate events, special occasions, or daily luxury travel, this service ensures you arrive in elegance and on time, with amenities that enhance your journey and personalized care tailored to your preferences."
  },
  {
    "name": "Chauffeur Driven Luxury Cab Pune",
    "description": "Chauffeur Driven Luxury Cab Pune offers premium chauffeur services using top-tier luxury vehicles, ideal for business executives, VIPs, and guests attending special events. Our drivers are experienced, discreet, and knowledgeable about Pune’s routes, ensuring smooth, stress-free travel with a focus on your comfort and privacy throughout your trip."
  },
  {
    "name": "Premium Car Hire with Driver Pune",
    "description": "Premium Car Hire with Driver Pune provides access to a curated selection of luxury cars available for hire with professional drivers. This service combines the sophistication of premium vehicles with the convenience of a reliable chauffeur, perfect for airport transfers, business meetings, and leisure outings around Pune."
  },
  {
    "name": "Executive Cab with Driver Pune",
    "description": "Executive Cab with Driver Pune caters specifically to professionals who require refined, timely, and efficient transportation. Featuring luxury sedans and SUVs, this service includes expert chauffeurs who ensure your journey is productive and relaxing, with door-to-door service tailored to your schedule."
  },
  {
    "name": "Luxury Sedan Rental Pune",
    "description": "Luxury Sedan Rental Pune offers elegant sedans equipped with modern amenities, perfect for solo travelers, couples, or small groups seeking premium comfort. Our vehicles are meticulously maintained, and drivers provide attentive service to ensure a smooth and stylish ride for any occasion."
  },
  {
    "name": "Luxury SUV Rental Pune",
    "description": "Luxury SUV Rental Pune provides spacious, powerful SUVs ideal for group travel or clients with extra luggage requirements. These vehicles combine rugged capability with luxurious interiors, ensuring a comfortable and secure journey handled by skilled chauffeurs familiar with Pune’s roads."
  },
  {
    "name": "Corporate Luxury Cab Pune",
    "description": "Corporate Luxury Cab Pune delivers premium transportation solutions tailored for business clients. With flexible packages, priority bookings, and professional chauffeurs, this service supports corporate travel needs while projecting an image of sophistication and professionalism for your company."
  },
  {
    "name": "Wedding Luxury Cab Pune",
    "description": "Wedding Luxury Cab Pune offers exquisite vehicles and chauffeur services specially designed for weddings and related events. From elegant sedans to luxury SUVs, our fleet ensures that the bride, groom, and guests arrive in style, with seamless coordination and attention to every detail to make your special day unforgettable."
  },
  {
    "name": "Best Luxury Cab Pune",
    "description": "Best Luxury Cab Pune is recognized for providing unmatched luxury cab services with a commitment to excellence, reliability, and customer satisfaction. Our premium fleet, professional drivers, and 24/7 availability make us the preferred choice for luxury transportation in Pune."
  },
  {
    "name": "Affordable Luxury Cab Pune",
    "description": "Affordable Luxury Cab Pune offers the finest luxury cab experience at competitive rates, making upscale transportation accessible without compromising on quality or comfort. Transparent pricing and no hidden charges ensure that you receive the best value for your money."
  },
  {
    "name": "Corporate Chauffeur Service Pune",
    "description": "Corporate Chauffeur Service Pune specializes in providing discreet and professional chauffeur-driven luxury vehicles for corporate executives and business travelers. Our drivers are trained in corporate etiquette, ensuring privacy, punctuality, and smooth travel tailored to business needs."
  },
  {
    "name": "Online Luxury Cab Booking Pune",
    "description": "Online Luxury Cab Booking Pune simplifies the process of reserving premium luxury cabs through an easy-to-use digital platform. Enjoy instant confirmations, real-time tracking, and flexible scheduling options, making luxury transportation in Pune seamless and convenient."
  },
  {
    "name": "Luxury Vehicle Hire Pune",
    "description": "Luxury Vehicle Hire Pune features an extensive fleet of high-end cars and SUVs available for hire with professional drivers. Whether for business, leisure, or special occasions, our vehicles offer superior comfort, style, and reliability to elevate your travel experience."
  },
  {
    "name": "Prestige Cab Pune",
    "description": "Prestige Cab Pune offers elite transportation services designed to meet the expectations of clients seeking the highest standards in luxury and professionalism. Our service guarantees immaculate vehicles, experienced chauffeurs, and tailored travel solutions for any luxury cab requirement."
  },
  {
    "name": "Luxury Driver Cab Pune",
    "description": "Luxury Driver Cab Pune provides professional drivers paired with premium vehicles to offer a smooth, comfortable, and sophisticated travel experience. Perfect for clients who value discretion, efficiency, and first-class service in every journey across Pune."
  }
],
"tableData": [
  ["Luxury Cab Rentals with Drivers in Pune", "Chauffeur Driven Luxury Cab Pune"],
  ["Premium Car Hire with Driver Pune", "Executive Cab with Driver Pune"],
  ["Luxury Sedan Rental Pune", "Luxury SUV Rental Pune"],
  ["Corporate Luxury Cab Pune", "Wedding Luxury Cab Pune"],
  ["Best Luxury Cab Pune", "Affordable Luxury Cab Pune"],
  ["Corporate Chauffeur Service Pune", "Online Luxury Cab Booking Pune"],
  ["Luxury Vehicle Hire Pune", "Prestige Cab Pune"],
  ["Luxury Driver Cab Pune", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Luxury Cab Rentals with Drivers in Pune",
    "WhyChoosedescription": "Aaryan Travels offers premium luxury cab rentals with professional drivers in Pune for a sophisticated travel experience."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Chauffeurs",
    "WhyChoosedescription": "Our skilled drivers provide punctual, polite, and professional service to make your ride comfortable."
  },
  {
    "WhyChooseheading": "Well-Maintained Luxury Vehicles",
    "WhyChoosedescription": "Travel in clean, sanitized, and air-conditioned luxury cars that are regularly serviced for your safety."
  },
  {
    "WhyChooseheading": "Drivers Familiar with Pune Roads",
    "WhyChoosedescription": "Our chauffeurs have extensive knowledge of Pune’s routes and traffic for efficient and smooth journeys."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Enjoy upfront pricing that covers all costs including fuel, tolls, and driver allowances for a hassle-free experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Bookings",
    "WhyChoosedescription": "Our support team is available round the clock to assist you with luxury cab rentals and inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term luxury cab rentals tailored to your travel needs."
  },
  {
    "WhyChooseheading": "Wide Range of Luxury Vehicle Options",
    "WhyChoosedescription": "Select from premium sedans, SUVs, and other luxury vehicles to match your preferences."
  }
]













  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer luxury cab rentals with drivers in Pune?',
    answer: 'Yes, Aaryan Travels provides premium luxury cab rentals with professional drivers in Pune for comfortable and stylish travel.',
  },
  {
    question: 'How can I book luxury cab rentals with drivers in Pune?',
    answer: 'You can book easily via our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of luxury vehicles are available for rentals in Pune?',
    answer: 'Aaryan Travels offers a fleet of luxury sedans, SUVs, and premium cars equipped with experienced chauffeurs.',
  },
  {
    question: 'Are the drivers trained for luxury cab services in Pune?',
    answer: 'Absolutely. Our drivers are licensed, well-trained, and committed to providing courteous and professional service.',
  },
  {
    question: 'Can I rent luxury cabs with drivers for airport transfers and outstation trips from Pune?',
    answer: 'Yes, Aaryan Travels offers luxury cab rentals with drivers for airport transfers, local travel, and outstation trips from Pune.',
  },
  {
    question: 'Is the luxury cab rental service with drivers available 24x7 in Pune?',
    answer: 'Yes, our luxury cab rental services are available round-the-clock to suit your travel plans.',
  },
  {
    question: 'Are safety and hygiene protocols followed in luxury cab rentals?',
    answer: 'All vehicles are regularly sanitized, and our drivers follow strict hygiene and safety guidelines.',
  },
  {
    question: 'What payment options are accepted for luxury cab rentals in Pune?',
    answer: 'We accept cash, digital wallets, UPI, credit/debit cards, and corporate account payments.',
  },
  {
    question: 'Is customer support available during luxury cab rental rides in Pune?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your rental experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Joshi',
    feedback: 'Aaryan Travels provided a luxurious ride with a professional driver in Pune — smooth and comfortable experience.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Deshpande',
    feedback: 'Excellent luxury cab rental service in Pune. The driver was courteous and the car was spotless. Highly recommend Aaryan Travels!',
    rating: 5,
  },
];

























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];







const luxuryCabPuneSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Luxury Cab Rentals with Drivers in Pune",
  "description": "Aaryan Travels offers chauffeur-driven luxury cab rentals in Pune, including premium sedans and SUVs for corporate, wedding, and executive travel.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": "Luxury Cab Rental Service with Drivers",
  "keywords": "Luxury Cab Rentals with Drivers in Pune, Chauffeur Driven Luxury Cab Pune, Premium Car Hire with Driver Pune, Executive Cab with Driver Pune, Luxury Sedan Rental Pune, Luxury SUV Rental Pune, Corporate Luxury Cab Pune, Wedding Luxury Cab Pune, Best Luxury Cab Pune, Affordable Luxury Cab Pune, Corporate Chauffeur Service Pune, Online Luxury Cab Booking Pune, Luxury Vehicle Hire Pune, Prestige Cab Pune, Luxury Driver Cab Pune"
};








  return (
    <div>

<Helmet>
  <title>Luxury Cab Rentals with Drivers in Pune | Premium Chauffeur Service | Aaryan Travels</title>
  <meta
    name="description"
    content="Book luxury cab rentals with drivers in Pune. Chauffeur-driven premium sedans and SUVs for corporate, wedding, and executive travel by Aaryan Travels."
  />
  <meta
    name="keywords"
    content="Luxury Cab Rentals with Drivers in Pune, Chauffeur Driven Luxury Cab Pune, Premium Car Hire with Driver Pune, Executive Cab with Driver Pune, Luxury Sedan Rental Pune, Luxury SUV Rental Pune, Corporate Luxury Cab Pune, Wedding Luxury Cab Pune, Best Luxury Cab Pune, Affordable Luxury Cab Pune, Corporate Chauffeur Service Pune, Online Luxury Cab Booking Pune, Luxury Vehicle Hire Pune, Prestige Cab Pune, Luxury Driver Cab Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(luxuryCabPuneSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/64.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurycabrentalswithdriverinpune;